import { render } from "./ScreenAdapter.vue?vue&type=template&id=adb9b49c&scoped=true"
import script from "./ScreenAdapter.vue?vue&type=script&lang=js"
export * from "./ScreenAdapter.vue?vue&type=script&lang=js"

import "./ScreenAdapter.vue?vue&type=style&index=0&id=adb9b49c&lang=scss&scoped=true"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-adb9b49c"]])

export default __exports__